import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Container } from '@pixi/react';
import { shallowEqual } from 'react-redux';
import { useAppSelector } from '../../../redux/store';
import { UsernameBadgeAnimationWrapper } from './usernameBadgeAnimationWrapper';
import { UsernameBadgeContents } from './usernameBadgeContents';
export const UsernameBadgeContainer = ({ seatIndex }) => {
    const bounds = useAppSelector((state) => state.gameDimensions.usernameBarBounds, shallowEqual);
    if (!bounds) {
        return null;
    }
    return (_jsx(Container, { interactiveChildren: false, x: bounds.x, y: bounds.y, children: _jsx(UsernameBadgeAnimationWrapper, { seatIndex: seatIndex, children: _jsx(UsernameBadgeContents, { seatIndex: seatIndex, bounds: bounds }) }) }));
};
